import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Typography } from "@mui/material";
import FullscreenLayout from "./FullscreenLayout";
import Link from "./lib/Link";

type Props = {
  backTo: string;
  // when set, the back link calls this instead of navigating to backTo
  onBack?: () => void;
  breadcrumbs: [string, string];
  children: React.ReactNode;
};

export default function FullscreenFlow({
  backTo,
  onBack,
  breadcrumbs,
  children,
}: Props) {
  return (
    <FullscreenLayout
      corner={
        <>
          <Link
            to={backTo}
            onClick={
              onBack
                ? (e) => {
                    // leave modified clicks (e.g. open in new tab) to the
                    // browser and RouterLink
                    if (
                      e.button !== 0 ||
                      e.metaKey ||
                      e.altKey ||
                      e.ctrlKey ||
                      e.shiftKey
                    )
                      return;
                    e.preventDefault();
                    onBack();
                  }
                : undefined
            }
            sx={{
              display: "flex",
              justifyContent: "center",
              cursor: "pointer",
            }}
            color="text.secondary"
          >
            <ArrowBackIcon sx={{ marginRight: 3 }} /> {breadcrumbs[0]}
          </Link>
          &nbsp;
          <Typography>
            /&nbsp;
            {breadcrumbs[1]}
          </Typography>
        </>
      }
    >
      {children}
    </FullscreenLayout>
  );
}
